(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  dialogs,
  account_services: accountServices,
  api_calls: apiCalls,
  communication,
  initPay
} = svs.tur.pay;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  getLocalizedWeekday
} = svs.utils.date;
const PRICE_PER_WEEK = 40;
const {
  playNextDrawDialog,
  shouldShowPlayNextDrawDialog,
  payAfterDepositDialog,
  fetchDrawData,
  getDrawData,
  getCloseTimeDescription,
  handlePayResponse,
  verifySelectedCharities,
  trackSuccessfulWagers
} = svs.tur.pay_lyckoplatsen;
const {
  Currency: formatCurrency,
  CurrencyFromJupiterString: formatCurrencyFromJupiterString
} = svs.utils.format;
const {
  logger
} = svs.tur.pay_lyckoplatsen;
function createWagerObject(_ref) {
  let {
    primaryDraw,
    secondaryDraw,
    numberOfWeeks,
    pinLocation,
    pinLocationType,
    lyckoplatsenName,
    locationName,
    charityId,
    isProlongination
  } = _ref;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const {
    lng,
    lat
  } = pinLocation;
  const geoBoardData = {
    boardProps: [],
    geoLoc: {
      latitude: lat === null || lat === void 0 ? void 0 : lat.toString().replace('.', ','),
      longitude: lng === null || lng === void 0 ? void 0 : lng.toString().replace('.', ',')
    },
    geoLocType: pinLocationType,
    geoLocName: lyckoplatsenName,
    charityId: charityId || 0
  };
  if (isSelfService && lyckoplatsenName === svs.tur.lyckoplatsen.utils.getDefaultLocationName() && locationName) {
    geoBoardData.geoLocName = locationName;
  }
  const currentDrawPrimary = primaryDraw.drawNumber;
  const currentDrawSecondary = secondaryDraw.drawNumber;
  const wagers = {
    bets: [{
      productId: 'GEO1',
      drawNum: currentDrawPrimary,
      numDraws: numberOfWeeks,
      betAmountSalesGroup1: formatCurrency(price, true),
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 1,
      geoBoardData
    }, {
      productId: 'GEO2',
      drawNum: currentDrawSecondary,
      numDraws: 0,
      betAmountSalesGroup1: '0,00',
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 0,
      geoBoardData
    }]
  };
  if (isProlongination) {
    wagers.bets[0].betProperties.push('PROLONGATION');
    wagers.bets[1].betProperties.push('PROLONGATION');
  }
  return wagers;
}
function setupPayParam(_ref2) {
  let {
    next
  } = _ref2;
  svs.utils.paramHandler.set({
    key: 'pay',
    value: 'true'
  });
  next();
}
function createApiWagers(_ref3) {
  let {
    next,
    wagers,
    primaryDraw,
    secondaryDraw
  } = _ref3;
  const apiWagers = wagers.map(wager => createWagerObject(_objectSpread(_objectSpread({}, wager), {}, {
    primaryDraw,
    secondaryDraw
  })));
  next({
    apiWagers
  });
}
function checkAccountBalance(_ref4) {
  let {
    next,
    cancel,
    saveState,
    price,
    product
  } = _ref4;
  if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit')) {
    svs.components.account_balance.get(true, balance => {
      if (price > formatCurrencyFromJupiterString(balance)) {
        logger.info("Not enough money. Price: ".concat(price, ", balance: ").concat(balance, ", using after pay dialog"));
        return payAfterDepositDialog({
          cancel,
          balance,
          product,
          price,
          saveState
        });
      }
      next({
        accountBalance: balance
      });
    });
  } else {
    accountServices.accountBalance({
      next,
      cancel,
      saveState,
      price,
      product
    });
  }
}
function numberToWord(number) {
  const words = {
    1: 'ett',
    2: 'två',
    3: 'tre',
    4: 'fyra',
    5: 'fem',
    6: 'sex',
    7: 'sju',
    8: 'åtta',
    9: 'nio',
    10: 'tio'
  };
  return words[number];
}
function pay(_ref5) {
  let {
    data,
    onDone,
    onError,
    saveState
  } = _ref5;
  const product = 'Lyckoplatsen';
  const isMultiWagers = Array.isArray(data);
  let wagers = Array.isArray(data) ? data.map(wager => _objectSpread({}, wager)) : [_objectSpread({}, data)];
  const price = wagers.reduce((totalPrice, wager) => totalPrice + PRICE_PER_WEEK * wager.numberOfWeeks, 0);
  const isAfterDeposit = wagers.some(wager => wager.isAfterDeposit) && svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit');
  const isProlongination = wagers.some(wager => wager.isProlongination);
  const numberOfWeeks = wagers[0].numberOfWeeks;
  let accountBalance;
  let primaryDraw;
  let secondaryDraw;
  let firstDraw;
  let lastDraw;
  let apiWagers;
  let regWagerResults;
  let successfulWagers;
  let failedWagers;
  const calls = [{
    fn: setupPayParam
  }, {
    in: () => ({
      price,
      product
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price,
      product
    }),
    fn: checkAccountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, {
    in: () => ({
      numberOfWeeks
    }),
    fn: getDrawData,
    out: args => ({
      primaryDraw,
      secondaryDraw,
      firstDraw,
      lastDraw
    } = args)
  }, {
    in: () => ({
      wagers,
      primaryDraw,
      secondaryDraw
    }),
    fn: createApiWagers,
    out: args => ({
      apiWagers
    } = args)
  }, shouldShowPlayNextDrawDialog({
    params: () => ({
      primaryDraw,
      secondaryDraw,
      wagers
    }),
    calls: () => [{
      in: () => ({
        regCloseTime: firstDraw.regCloseTime
      }),
      fn: playNextDrawDialog
    }]
  }), ...(isAfterDeposit ? [] : [{
    in: () => ({
      price,
      accountBalance,
      product,
      title: "Vill du betala ".concat(numberToWord(wagers.length), " spel p\xE5<br/>").concat(product, " f\xF6r ").concat(price, " kr?"),
      messages: ["Spell\xE4ngd: ".concat(numberOfWeeks, " veckor, ").concat(getLocalizedWeekday(firstDraw.regCloseTime, true, true), " till ").concat(getLocalizedWeekday(lastDraw.regCloseTime, true, true), "."), "".concat(product, " g\xE5r att annullera.")]
    }),
    fn: dialogs.confirmPayment
  }]), ...(isProlongination ? [{
    in: () => ({
      wagers
    }),
    fn: verifySelectedCharities,
    out: args => ({
      wagers
    } = args)
  }] : []), function mainPaymentSequence() {
    var _apiWagers;
    if ((_apiWagers = apiWagers) !== null && _apiWagers !== void 0 && _apiWagers.length) {
      return {
        calls: [{
          in: () => ({
            wagers: apiWagers
          }),
          fn: apiCalls.payWagers,
          out: args => ({
            regWagerResults
          } = args)
        }, {
          in: () => ({
            onError,
            regWagerResults,
            wagers,
            apiWagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => ({
            successfulWagers,
            incompleteWagers: apiWagers,
            failedWagers
          } = args)
        }, mainPaymentSequence]
      };
    }
  }, {
    in: () => ({
      successfulWagers
    }),
    fn: trackSuccessfulWagers
  }, {
    in: () => ({
      product: 'lyckoplatsen'
    }),
    fn: communication.correctionEmail
  }];
  initPay({
    calls,
    saveState,
    cancel: () => {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
    },
    done: () => {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
      if (isMultiWagers) {
        onDone === null || onDone === void 0 || onDone({
          successfulWagers,
          failedWagers
        });
      } else {
        const {
          wager,
          wagerClientSerial
        } = successfulWagers[0];
        onDone === null || onDone === void 0 || onDone({
          wagerId: wagerClientSerial,
          wasInvalidCharity: wager.wasInvalidCharity
        });
      }
    },
    error: error => {
      onError === null || onError === void 0 || onError({
        error
      });
    }
  });
}
async function addToCart(data, onDone) {
  const {
    product,
    numberOfWeeks
  } = data;
  const drawData = await fetchDrawData(numberOfWeeks);
  const primaryDraw = drawData.primaryDraw;
  data.primaryDraw = primaryDraw;
  data.secondaryDraw = drawData.secondaryDraw;
  const firstDraw = drawData.firstDraw;
  const wagers = createWagerObject(data);
  wagers.bets[0].geoBoardData.reverseGeo = data.locationName;
  wagers.bets[1].geoBoardData.reverseGeo = data.locationName;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const productProperties = {
    wagers,
    isLive: false,
    headers: {
      source: 'SvS:TB:ITS'
    },
    productFlag: product,
    productTitle: product,
    productBrand: product,
    cost: price,
    description: getCloseTimeDescription(firstDraw.regCloseTime)
  };
  const {
    generateProductItem,
    getCartInstance
  } = svs.components.selfserviceCart;
  const wagerWrapper = generateProductItem(productProperties);
  getCartInstance().actions.addItem(wagerWrapper, error => {
    if (!error) {
      onDone === null || onDone === void 0 || onDone();
    }
  });
}
function makePayment(_ref6) {
  let {
    data,
    onDone,
    onError,
    saveState
  } = _ref6;
  if (isSelfService) {
    addToCart(data, onDone);
  } else {
    pay({
      data,
      onDone,
      onError,
      saveState
    });
  }
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  makePayment,
  createWagerObject,
  PRICE_PER_WEEK
});

 })(window);